import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export function Header() {
  return (
    <header className="bg-white shadow-sm py-6">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <Sparkles className="w-8 h-8 text-indigo-600" />
          <span className="text-xl font-bold text-gray-900">Best Free AI Tools</span>
        </Link>
        <nav className="flex items-center gap-6">
          <Link
            to="/best-free-blog-title-generator-tool"
            className="text-indigo-600 font-medium hover:text-indigo-700"
          >
            Blog Title Generator
          </Link>
          <a
            href="https://getqualityleadsfast.com/marketing-optin"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#e94e38] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#d03d29] transition-colors duration-200"
          >
            Ultimate Marketing Tool
          </a>
        </nav>
      </div>
    </header>
  );
}